import { makeAutoObservable } from "mobx";

export class ManufacturerDescription {
    ManufacturerId: number;
    ManufacturerName: string;
    Description: string;
    ModifiedByName: string;
    ModifiedDate: Date;
    ModifiedDateString: string;
    constructor() {
        makeAutoObservable(this);
        this.ManufacturerId = null;
        this.ManufacturerName = null;
        this.Description = null;
        this.ModifiedByName = null;
        this.ModifiedDate = null;
        this.ModifiedDateString = null;
    }
}